import useTranslation from 'hooks/useTranslation';
import StatusChip from '../Common/StatusChip';
import useOptions from '../Options/OptionsContext/useOptions';
import * as yup from 'yup';
import { DATE_FORMATS, formatDate } from 'utils/date';
import { CompleteTodoButton } from './CompleteTodoButton';
import { Link } from 'react-router-dom';
import { ToggleNoteImportanceIcon } from './ToggleNoteImportanceIcon';
import TruncatedText from 'components/Common/TruncatedText';


const useTodoFields = (setRefetchTrigger) => {
  const { courses } = useOptions();
  const { t } = useTranslation();
  return [
    {
      name: 'content',
      cellRenderer: (row) => <TruncatedText text={row.content} />,
      showInTable: true,
      type: 'text',
      fieldProps: {
        label: 'Tartalom',
        multiline: true,
      },
      rule: yup.string().trim().required('Tartalom megadása kötelező')
    },
    {
      name: 'course',
      cellRenderer: (row) => row.course?.value ?? '-',
      showInTable: true,
      type: 'select',
      fieldProps: {
        label: 'Tanfolyam',
        options: [...courses, {key: '', value: 'Nincs kapcsolódó kurzus'}],
      },
      rule: yup.string().nullable()
    },
    {
      name: 'student',
      cellRenderer: (row) => <Link to={`/students/${row.student}`}>{row.studentDetails.name}</Link>,
      showInTable: true,
      hiddenFormField: true,
      fieldProps: {
        label: 'Tanuló',
      },
    },
    {
      name: 'email',
      cellRenderer: (row) => row.studentDetails.email,
      showInTable: true,
      fieldProps: {
        label: 'E-mail',
      },
    },
    {
      name: 'phone',
      cellRenderer: (row) => row.studentDetails.phone ?? '-',
      showInTable: true,
      fieldProps: {
        label: 'Telefonszám',
      },
    },
    {
      name: 'deadline',
      type: 'date',
      cellRenderer: (row) => row.deadline != null ? formatDate(row.deadline, DATE_FORMATS.shortDate) : '-',
      showInTable: true,
      fieldProps: {
        label: 'Határidő',
        helperText: t('helpertext.note-deadline')
      },
      rule: yup.string().nullable()
    },
    {
      name: 'status',
      cellRenderer: (row) => row.status != null ? <StatusChip entity={'note'} status={row.status} /> : '-',
      showInTable: true,
      fieldProps: {
        label: 'Státusz',
      },
    },
    {
      name: '',
      cellRenderer: (row) => row.status != null && row.isDone === '0' ? <CompleteTodoButton noteId={row.id} lastModification={row.last_modified_on} setRefetchTrigger={setRefetchTrigger} /> : '',
      showInTable: true,
      fieldProps: {
        label: '',
      },
    },
    {
      name: 'last_modified_by',
      cellRenderer: (row) => row.last_modified_by != null ? row.last_modified_by : 'Rendszer',
      showInTable: true,
      fieldProps: {
        label: 'Utolsó módosító',
      },
    },
    {
      name: 'important',
      cellRenderer: (row) => <ToggleNoteImportanceIcon noteId={row.id} important={row.important} lastModification={row.last_modified_on} setRefetchTrigger={setRefetchTrigger} />,
      showInTable: true,
      type: 'checkbox',
      fieldProps: {
        label: '',
        checkBoxLabel: 'Csillagozott'
      },
    },
    {
      name: 'last_modified_on',
      hiddenFormField: true
    },
  ];
};

export default useTodoFields;
